define('Store.Selector.Results', [
	'Backbone',
	'SC.Configuration',
	'store_selector_results.tpl',
	'Store.Selector.Hours.Helper'
], function StoreSelectorResults(
	Backbone,
	Configuration,
	storeSelectorResultsTpl,
	HoursHelper
) {
	'use strict';

	return Backbone.View.extend({
		template: storeSelectorResultsTpl,
		initialize: function initialize(options) {
			this.profile = options.profile;
			this.listenTo(this.collection, 'sync', this.render);
		},
		getBoundariesMessage: function getBoundariesMessage() {
			var firstStore = this.collection.at(0);
			var firstStoreDelivery = firstStore && firstStore.get('delivery');
			if (!firstStoreDelivery || !firstStoreDelivery.shipping || !firstStoreDelivery.delivery) {
				return '';
			}
			if (firstStoreDelivery.delivery.zipCode) {
				return Configuration.get('store.selector.messages.deliveryStateAndDeliveryAllowed');
			} else if (firstStoreDelivery.delivery.broadRange) {
				return Configuration.get('store.selector.messages.deliveryStateAndDeliveryNotAllowed');
			} else if (firstStoreDelivery.shipping.zipCode) {
				return Configuration.get('store.selector.messages.notDeliveryStateShippingAllowed');
			}
			return Configuration.get('store.selector.messages.shippingNotAllowed');
		},
		getContext: function getContext() {
			var selectedStore = this.profile.get('store') && this.profile.get('store').internalid;
			var collectionLength = this.collection.length;
			var isGoogleDistanceEnabled = Configuration.get('store.enableGoogleCalculation');
			var message = this.getBoundariesMessage();

			return {
				showResults: this.collection.length > 0,
				showMessage: !!message,
				message: message,
				results: this.collection.map(function eachResult(s, i) {
					return {
						isLast: i === collectionLength - 1,
						internalid: s.get('internalid'),
						storeName: s.get('name'),
						addressLine1: s.get('addr1') + ' ' + s.get('addr2'),
						addressLine2: s.get('city') + ' ' + s.get('zip') + ' ' + s.get('state'),
						isSelected: s.get('internalid') === selectedStore,
						showDistance: isGoogleDistanceEnabled && s.get('distance') && s.get('distance').text,
						distanceText: s.get('distance') && s.get('distance').text,
						directionsLink: 'https://www.google.com/maps/dir//'
						+ (s.get('addr1') + ', ' + s.get('city') + ', '
						+ s.get('state') + ' ' + s.get('zip') + ', ' + s.get('country')
						).replace(/\|/g, ''),
						isOpen: HoursHelper.isStoreOpen(s),
						openHoursToday: HoursHelper.getTodayHoursString(s)
					};
				})
			};
		}
	});
});
